// @mui
import styled from '@emotion/styled';
import { FormLabel, Stack, Typography } from '@mui/material';

// form
import { useFormContext, Controller } from 'react-hook-form';

// ----------------------------------------------------------------------

interface RHFDatePickerProps {
  name: string;
  outerLabel?: React.ReactNode;
  disabled?: boolean;
  defaultValue?: string;
  onChange?: (_date: string | null) => void;
}

const StyledInput = styled('input')(({ theme }: any) => ({
  padding: '16px',
  borderRadius: '8px',
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.grey[500],
  border: `1px solid ${theme.palette.grey[200]}`,
  cursor: 'default',
  opacity: 1,
  '&::-webkit-calendar-picker-indicator': {
    filter:
      'brightness(0) saturate(100%) invert(15%) sepia(100%) saturate(7463%) hue-rotate(357deg) brightness(95%) contrast(118%)',
  },
}));

export function RHFDatePicker({
  name,
  outerLabel,
  disabled = false,
  defaultValue = '',
  onChange: customOnChange,
}: RHFDatePickerProps): JSX.Element {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const error = errors[name];
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { value, onChange, ...field } }) =>
        <Stack gap="0.6rem" mt={1}>
          {outerLabel && (
            <FormLabel sx={{ fontSize: 12 }}>{outerLabel}</FormLabel>
          )}

          <StyledInput
            {...field}
            type="date"
            disabled={disabled}
            value={value || ''}
            onChange={(e) => {
              const newValue = e.target.value || null;
              onChange(newValue);
              customOnChange?.(newValue);
            }}
            sx={{
              cursor: disabled ? 'not-allowed' : 'default',
              opacity: disabled ? 0.6 : 1,
            }}
          />
          {error && (
            <Typography variant="caption" color="error">
              {error.message as string}
            </Typography>
          )}
        </Stack>

      }
    />
  );
}
